import gql from 'graphql-tag';

export const GET_CONVERSATIONS = gql`
  query getConversationsQuery {
    me {
      id
      conversations {
        uuid
        active
        createdAt
        kind
        coach {
          uuid
          email
          firstName
          lastName
          role
          avatar
        }
        member {
          uuid
          email
          firstName
          lastName
          role
          avatar
        }
        newestMessage {
          uuid
          senderUuid
          receiverUuid
          content
          sentAt
          readAt
          conversationUuid
          messageResources {
            uuid
            order
            meditationId
            programId
            companyAdditionalBenefitId
          }
        }
        myNewestMessage {
          uuid
        }
      }
    }
  }
`;

export const GET_MESSAGES = gql`
  query getMessagesQuery($conversationUuid: UUID!, $after: UUID) {
    getMessages(conversationUuid: $conversationUuid, perPage: 10, after: $after) {
      messages {
        uuid
        senderUuid
        receiverUuid
        content
        sentAt
        readAt
        conversationUuid
        messageResources {
          uuid
          order
          meditationId
          programId
          companyAdditionalBenefitId
        }
      }
      pageInfo {
        oldestMessageUuid
        conversationUuid
      }
    }
  }
`;

export const GET_PARTNERS = gql`
  query getPartnersQuery {
    partners {
      uuid
      firstName
      lastName
      email
      localTimezone
      conversationUuid
      memberAssignments {
        uuid
        active
        createdAt
        coach {
          uuid
        }
      }
    }
  }
`;

export const GET_MESSAGE_RESOURCES = gql`
  query getMessageResources {
    meditations {
      id
      name
      image
    }
    programs {
      id
      name
      image
    }
  }
`;

export const GET_PAGINATED_CONVERSATIONS = gql`
  query getConversations(
    $uuid: UUID
    $active: Boolean
    $providerUuid: UUID
    $memberUuid: UUID
    $memberName: String
    $memberEmail: String
    $memberCompany: String
    $orderBy: String
    $first: Int
    $before: String
    $after: String
  ) {
    conversations(
      uuid: $uuid
      active: $active
      providerUuid: $providerUuid
      memberUuid: $memberUuid
      memberName: $memberName
      memberEmail: $memberEmail
      memberCompany: $memberCompany
      orderBy: $orderBy
      first: $first
      before: $before
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          active
          uuid
          createdAt
          isNewMatch
          isMatchedOverFiveDaysAgo
          member {
            uuid
            email
            firstName
            lastName
            role
            avatar
          }
          newestMessage {
            uuid
            senderUuid
            receiverUuid
            content
            sentAt
            readAt
            conversationUuid
          }
        }
      }
    }
  }
`;
